webpackJsonp([1],{

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(281);

var _promise2 = _interopRequireDefault(_promise);

exports.ajax = ajax;

var _axios = __webpack_require__(259);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(548);

var _qs2 = _interopRequireDefault(_qs);

var _elementUi = __webpack_require__(151);

var _main = __webpack_require__(163);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';

_axios2.default.defaults.baseURL = '/';function ajax(url, params, method) {
    return new _promise2.default(function (resolve, reject) {
        if (method && method == 'get') {
            _axios2.default.get(url, _qs2.default.stringify(params)).then(function (response) {
                if (response.data.code == -2) {
                    _elementUi.MessageBox.alert('会话已过期，3秒后将自动跳转到开发者中心', '会话已过期', {
                        type: 'warning',
                        showClose: false,
                        callback: function callback(action) {
                            window.location.href = 'https://developer.lm.virbox.com';
                        }
                    });
                    setTimeout(function () {
                        _elementUi.MessageBox.close();
                        window.location.href = 'https://developer.lm.virbox.com';
                    }, 3000);
                } else {
                    resolve(response.data);
                };
            }).catch(function (error) {
                reject(error);
            });
        } else {
            _axios2.default.post(url, _qs2.default.stringify(params)).then(function (response) {
                if (response.data.code == -2) {
                    _elementUi.MessageBox.alert('会话已过期，3秒后将自动跳转到开发者中心', '会话已过期', {
                        type: 'warning',
                        showClose: false,
                        callback: function callback(action) {
                            window.location.href = 'https://developer.lm.virbox.com';
                        }
                    });
                    setTimeout(function () {
                        _elementUi.MessageBox.close();
                        window.location.href = 'https://developer.lm.virbox.com';
                    }, 3000);
                } else {
                    resolve(response.data);
                };
            }).catch(function (error) {
                reject(error);
            });
        };
    });
};

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.router = undefined;

__webpack_require__(230);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(235);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(151);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(231);

__webpack_require__(233);

var _vueRouter = __webpack_require__(236);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _routes = __webpack_require__(229);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(232);

var _vueClipboard = __webpack_require__(234);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueClipboard2.default);

var router = exports.router = new _vueRouter2.default({
    base: 'package',
    routes: _routes2.default
});

new _vue2.default({
    router: router,
    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(556);

var _Home2 = _interopRequireDefault(_Home);

var _SearchLicense = __webpack_require__(557);

var _SearchLicense2 = _interopRequireDefault(_SearchLicense);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/',
    redirect: '/searchLicense',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-bar-chart',
    children: [{ path: '/searchLicense', component: _SearchLicense2.default, name: 'SearchLicense' }]
}];

exports.default = routes;

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(150)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(559),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(162);

exports.default = {
	data: function data() {
		return {};
	},

	methods: {},
	mounted: function mounted() {}
};

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(162);

exports.default = {
	data: function data() {
		return {
			fileNameC2D: '',
			fileNameD2C: '',
			licenseListData: [],
			snLicenseListData: [],
			LicenseObj: {},
			type: '1',
			tabsActive: '1'
		};
	},

	filters: {
		isForeverFilter: function isForeverFilter(val) {
			if (val == 1) {
				return '永久';
			} else {
				return '非永久';
			};
		},

		commonFilter: function commonFilter(val) {
			if (!val) {
				return '--';
			} else {
				return val;
			};
		},

		bindMaxLimitFilter: function bindMaxLimitFilter(val) {
			if (val === 0) {
				return '不限制';
			} else {
				return val;
			};
		},

		concurrentFilter: function concurrentFilter(hasConcurrent, concurrentType, concurrent) {
			if (hasConcurrent == false) {
				return '单机许可';
			} else {
				var concurrentTypeName = concurrentType == 'process' ? '进程' : '会话';
				return '集团许可 ' + concurrentTypeName + '(用户数: ' + concurrent + ')';
			};
		}
	},
	methods: {
		isForeverFormatter: function isForeverFormatter(row, index) {
			if (row.isForever == 1) {
				return '永久';
			} else {
				return '非永久';
			};
		},
		licenseFormFormatter: function licenseFormFormatter(row, index) {
			if (row.licenseForm == 1) {
				return '云锁';
			} else {
				return '软锁';
			};
		},
		contactTypeFormatter: function contactTypeFormatter(row, index) {
			if (row.phone && !row.email) {
				return row.phone;
			} else if (!row.phone && row.email) {
				return row.email;
			} else if (row.phone && row.email) {
				return row.phone + ' / ' + row.email;
			} else {
				return '';
			};
		},
		selectChange: function selectChange() {
			this.licenseListData = [];
			this.snLicenseListData = [];
			this.LicenseObj = {};
			this.fileNameC2D = '';
			this.fileNameD2C = '';
			this.tabsActive = '1';
		},
		searchLicenseC2D: function searchLicenseC2D() {
			if (!this.fileNameC2D) {
				this.$message({
					message: '请选择C2D文件',
					type: 'warning'
				});
			} else {
				this.$refs.uploadC2D.submit();
			};
		},
		searchLicenseD2C: function searchLicenseD2C() {
			if (!this.fileNameD2C) {
				this.$message({
					message: '请选择D2C文件',
					type: 'warning'
				});
			} else {
				this.$refs.uploadD2C.submit();
			};
		},
		uploadC2DSuccess: function uploadC2DSuccess(response, file, fileList) {
			if (response.code == 0) {
				if (response.data.licenses.length == 0 && response.data.licenseKey.length > 0) {
					this.tabsActive = '2';
				};
				this.licenseListData = response.data.licenses;
				this.snLicenseListData = response.data.licenseKey;
			} else {
				this.$nextTick(function () {
					this.fileNameC2D = '';
					this.$refs.uploadC2D.clearFiles();
				});
				this.licenseListData = [];
				this.snLicenseListData = [];

				this.$message({
					message: response.desc,
					type: 'warning'
				});
			};
		},
		uploadD2CSuccess: function uploadD2CSuccess(response, file, fileList) {
			if (response.code == 0) {
				this.LicenseObj = response.data;
			} else {
				this.$nextTick(function () {
					this.fileNameD2C = '';
					this.$refs.uploadD2C.clearFiles();
				});
				this.LicenseObj = {};

				this.$message({
					message: response.desc,
					type: 'warning'
				});
			};
		},
		uploadC2DChange: function uploadC2DChange(file, fileList) {
			this.fileNameC2D = file.name;
		},
		uploadD2CChange: function uploadD2CChange(file, fileList) {
			this.fileNameD2C = file.name;
		}
	},
	mounted: function mounted() {}
};

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/keep-record.d0289dc.png";

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(150)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(558),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(150)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(560),
  /* scopeId */
  "data-v-abf311b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "sense-container"
  }, [_c('div', {
    staticClass: "sense-header"
  }, [_c('div', {
    staticClass: "sense-header-box clearfix"
  }, [_c('h1', {
    staticClass: "fl"
  }, [_vm._v("工具")]), _vm._v(" "), _c('div', {
    staticClass: "sense-nav fl"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal",
      "background-color": "#001529"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('router-link', {
    staticClass: "tag-list",
    attrs: {
      "tag": "span",
      "to": "/searchLicense"
    }
  }, [_vm._v("C2D/D2C反查许可")])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sense-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-footer"
  }, [_vm._v("\n\t\t北京深盾科技股份有限公司 ©\n\t\t"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("京ICP备16009104号")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025663"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(555)
    }
  }), _vm._v("京公网安备 11010802025663号")])])])
},staticRenderFns: []}

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-search sense-search-c2d",
    staticStyle: {
      "padding-bottom": "22px"
    }
  }, [_c('el-row', [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "68px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "medium"
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "C2D",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "D2C",
      "value": "2"
    }
  })], 1), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '1'),
      expression: "type == '1'"
    }],
    ref: "uploadC2D",
    staticClass: "upload",
    attrs: {
      "action": "/uploadC2D.do",
      "name": "data",
      "multiple": false,
      "show-file-list": false,
      "auto-upload": false,
      "on-change": _vm.uploadC2DChange,
      "on-success": _vm.uploadC2DSuccess
    }
  }, [_c('el-input', {
    attrs: {
      "slot": "trigger",
      "size": "medium",
      "placeholder": "点击选择C2D文件",
      "maxlength": "64",
      "readonly": ""
    },
    slot: "trigger",
    model: {
      value: (_vm.fileNameC2D),
      callback: function($$v) {
        _vm.fileNameC2D = $$v
      },
      expression: "fileNameC2D"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '1'),
      expression: "type == '1'"
    }],
    staticClass: "search-btn",
    staticStyle: {
      "margin-left": "20px",
      "top": "0px"
    },
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.searchLicenseC2D
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '2'),
      expression: "type == '2'"
    }],
    ref: "uploadD2C",
    staticClass: "upload",
    attrs: {
      "action": "/uploadD2C.do",
      "name": "data",
      "multiple": false,
      "show-file-list": false,
      "auto-upload": false,
      "on-change": _vm.uploadD2CChange,
      "on-success": _vm.uploadD2CSuccess
    }
  }, [_c('el-input', {
    attrs: {
      "slot": "trigger",
      "size": "medium",
      "placeholder": "点击选择D2C文件",
      "maxlength": "64",
      "readonly": ""
    },
    slot: "trigger",
    model: {
      value: (_vm.fileNameD2C),
      callback: function($$v) {
        _vm.fileNameD2C = $$v
      },
      expression: "fileNameD2C"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '2'),
      expression: "type == '2'"
    }],
    staticClass: "search-btn",
    staticStyle: {
      "margin-left": "20px",
      "top": "0px"
    },
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.searchLicenseD2C
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '1'),
      expression: "type == '1'"
    }],
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabsActive),
      callback: function($$v) {
        _vm.tabsActive = $$v
      },
      expression: "tabsActive"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "账号许可",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "sense-table-list sense-table-ellipsis"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.licenseListData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "账号",
      "min-width": "12%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "用户名称",
      "min-width": "8%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "templateName",
      "label": "模板名称",
      "min-width": "11%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "min-width": "11%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "licenseId",
      "label": "许可ID",
      "min-width": "8%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.isForeverFormatter,
      "label": "是否永久",
      "min-width": "7%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startTime",
      "label": "许可开始时间",
      "min-width": "12%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endTime",
      "label": "许可结束时间",
      "min-width": "12%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "签发时间",
      "min-width": "12%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.licenseFormFormatter,
      "label": "许可形式",
      "min-width": "7%"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "授权码许可",
      "name": "2"
    }
  }, [(_vm.tabsActive == '2') ? _c('div', {
    staticClass: "sense-table-list sense-table-ellipsis"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.snLicenseListData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sn",
      "label": "授权码",
      "min-width": "18%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "templateName",
      "label": "授权码模板",
      "min-width": "14%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "用户名称",
      "min-width": "13%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.contactTypeFormatter,
      "label": "联系方式",
      "min-width": "16%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "系统平台",
      "min-width": "8%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.platform == 7) ? _c('em', {
          staticClass: "ssicon ss-windows",
          attrs: {
            "title": "Windows"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.platform == 7) ? _c('em', {
          staticClass: "ssicon ss-linux",
          attrs: {
            "title": "Linux"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.platform == 7) ? _c('em', {
          staticClass: "ssicon ss-mac",
          attrs: {
            "title": "Mac"
          }
        }) : _vm._e(), _vm._v(" "), ((scope.row.platform & 24) > 0) ? _c('em', {
          staticClass: "ssicon ss-android",
          attrs: {
            "title": "Android"
          }
        }) : _vm._e(), _vm._v(" "), ((scope.row.platform & 24) > 0) ? _c('em', {
          staticClass: "arm-linux-icon",
          attrs: {
            "title": "ARM Linux"
          }
        }) : _vm._e()]
      }
    }], null, false, 2194013501)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createAt",
      "label": "签发时间",
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exchangeAt",
      "label": "绑定时间",
      "min-width": "15%"
    }
  })], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '2'),
      expression: "type == '2'"
    }],
    staticClass: "sense-table-list sense-table-ellipsis sense-detail"
  }, [(_vm.LicenseObj.resultType == 2) ? _c('div', {
    staticClass: "sense-detail-block"
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授权码："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.LicenseObj.licenseKey))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "系统平台："
    }
  }, [(_vm.LicenseObj.platform == 7) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t传统 (\n\t\t\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-windows",
    attrs: {
      "title": "Windows"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-linux",
    attrs: {
      "title": "Linux"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-mac",
    attrs: {
      "title": "Mac"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), ((_vm.LicenseObj.platform & 24) > 0) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t智能(\n\t\t\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-android",
    attrs: {
      "title": "Android"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "arm-linux-icon",
    attrs: {
      "title": "ARM Linux"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "终端ID："
    }
  }, [_c('div', {
    staticClass: "sense-text sense-ellipsis",
    attrs: {
      "title": _vm.LicenseObj.machineId
    }
  }, [_vm._v(_vm._s(_vm.LicenseObj.machineId))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "终端名称："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.LicenseObj.terminalName))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否永久："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("isForeverFilter")(_vm.LicenseObj.isForever)))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开始时间："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.LicenseObj.startTime)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "时间跨度："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.LicenseObj.spanTime)))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结束时间："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.LicenseObj.endTime)))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.LicenseObj.platform == 7) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "许可类型："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("concurrentFilter")(_vm.LicenseObj.hasConcurrent, _vm.LicenseObj.concurrentType, _vm.LicenseObj.concurrent)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.LicenseObj.hasConcurrent != true) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "同时绑定设备数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.LicenseObj.bindLimit))])])], 1) : _vm._e(), _vm._v(" "), (_vm.LicenseObj.platform == 7 && _vm.LicenseObj.hasConcurrent != true) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "累积绑定设备数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("bindMaxLimitFilter")(_vm.LicenseObj.bindMaxLimit)))])])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.LicenseObj.resultType == 3) ? _c('div', {
    staticClass: "sense-detail-block"
  }, [_c('el-form', {
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "外壳号："
    }
  }, [_c('div', {
    staticClass: "sense-text sense-ellipsis",
    attrs: {
      "title": _vm.LicenseObj.shellNumber
    }
  }, [_vm._v(_vm._s(_vm.LicenseObj.shellNumber))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "序列号："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.LicenseObj.dongleId))])])], 1)], 1)], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "all-dialog"
  })])
},staticRenderFns: []}

/***/ })

},[163]);


// WEBPACK FOOTER //
// static/js/app.c92839fbf39a0ea12d58.js